export const RANGED_FIELD = 'RangedField'
export const LAGVIS_LIST = 'LagvisList'
export const SAMLAGS_FYLKE = 'SamlagsFylke'
export const SAMLAGS_FYLKE_SHOOTERS = 'SamlagsFylkeShooters'
